// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import classNames from 'classnames/bind';

import style from './PaymentBox.scss';
import commonStyle from '../../PaymentBoxViewCommon.scss';
import icons from '../../../../../assets/styles/icons.scss';

import type { TravelerReceipt, TravelerReceiptLine } from '../../../../../entities';

type Props = {
  receipt: TravelerReceipt;
};

type State = {
  open: boolean;
};

const messages = defineMessages({
  flight: {
    id: 'payments.paymentBox.flight',
  },
  state: {
    id: 'payments.paymentBox.state',
  },
});

export default class PaymentBox extends Component<Props, State> {
  state = {
    open: false,
  };

  handleClickHeader() {
    this.setState((prevState: State) => {
      return { open: !prevState.open }
    });
  }

  render() {
    const { receipt } = this.props;
    const { open } = this.state;

    const detailItems = receipt && receipt.lines && receipt.lines.map((line: TravelerReceiptLine, n: number) => (
      <tr key={n}>
        <FormattedMessage id="payments.paymentBox.order">{
          txt => <td className={commonStyle.name}>{txt} {line.name}</td>
        }</FormattedMessage>
        <td className={commonStyle.price}>
          $ {line.price}
        </td>
      </tr>));
    const receiptTotal = receipt && receipt.lines && receipt.lines.reduce((acc, line) => acc + parseFloat(line.price), 0);
    /*const canceledItems = payment && payment.cancellations.map((item: PaymentLine, n: number) => (
      <tr key={n}>
        <FormattedMessage id="payments.paymentBox.product">{
          txt => <td>{txt} {item.transactionId}</td>
        }</FormattedMessage>
        <td className={commonStyle.alignRight}>
          $ {item.price}
        </td>
      </tr>
    ));*/

    return (
      <article className={commonStyle.paymentWrap}>
        <button className={classNames(commonStyle.paymentHeader, { [commonStyle.open]: open })}
                onClick={this.handleClickHeader.bind(this)}>
          <div className={commonStyle.title}>
            <h2>
              {this.context.intl.formatMessage(messages.flight)} {receipt.flight.departureAdmin2.name} - {receipt.flight.arrivalAdmin2.name}
            </h2>
            {/*<p>{this.context.intl.formatMessage(messages.state)} {receipt.state}</p>*/}
          </div>
          <i className={!open ? icons.iconChevronDownLight : icons.iconChevronUpLight}/>
        </button>
        <section className={classNames(commonStyle.box, { [commonStyle.open]: open })}>
          <section className={commonStyle.tableWrap}>
            <table>
              <tbody className={style.received}>
              {detailItems}
              </tbody>
            </table>
            {/*!!canceledItems.length && <table>
              <tbody className={style.received}>
              <tr className={style.canceled}>
                <FormattedMessage id="payments.paymentBox.canceled">{
                  txt => <td>{txt}</td>
                }</FormattedMessage>
              </tr>
              {canceledItems}
              </tbody>
            </table>*/}
            <table>
              <tbody className={style.received}>
              <tr className={commonStyle.total}>
                <FormattedMessage id="order.summary.title.total">{
                  text => <td>{text}</td>
                }</FormattedMessage>
                <td className={commonStyle.alignRight}>$ {receiptTotal.toFixed(2)}</td>
              </tr>
              </tbody>
            </table>
          </section>
          {/*<section className={commonStyle.download}>
            <FormattedMessage id="payments.paymentBox.download">{
              text => <a href={payment.pdf}
                         className={classNames(buttonStyle.btn, buttonStyle.lightBlueInverse)}
                         download="myPayment"><i className={icons.iconArrowUpLight}/> {text}</a>
            }</FormattedMessage>
          </section>*/}
        </section>
      </article>)
  }
}

PaymentBox.propTypes = {
  receipt: PropTypes.object.isRequired,
};

PaymentBox.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/payments/components/PaymentsReceived/PaymentBox/PaymentBox.jsx